$(function () {

	$('.geo_items_parent').on('change','.geo_items', function () {

		var stdataloading = '';
		var item_id = $(this).val();
		var item_js_id = $(this).attr("id");
		var next_el;
		var int_item_js_id;

		switch (item_js_id) {
		case 'country':
			int_item_js_id = 1;
			next_el = 'region';
			$('#city')
				.attr('disabled', true)
				.html('<option></option>');
			break;
		case 'region':
			int_item_js_id = 2;
			next_el = 'city';
			break;
		case 'city':
			int_item_js_id = 3;
			break;
		}
		if(!item_id){
			$('#' + next_el + ' option:first').attr("selected", "selected");
			$('#' + next_el).attr('disabled', true);
			return (false);
		}

		next_el = $('#' + next_el);

		// Очищаем второй селект
		next_el
			.attr('disabled', true)
			.html('<option value="">' + stdataloading + '</option>');

		$.ajax({
			url : '/geo/ajax_get_region/' + item_id + '/' + int_item_js_id,
			dataType : "json",
			type : "post",
			success : function (result) {

				var options = '';
				$(result.regions).each(function () {
					// и добавляем в селект по региону
					options += '<option value="' + $(this).attr('id') + '">' + $(this).attr('title') + '</option>';
				});
				next_el
					.html(options)
					.attr('disabled', false)
					.trigger("change");
			}
		});
	});
});
